import { render, staticRenderFns } from "./OnboardingMatchingMissionFrequencyPage.vue?vue&type=template&id=c616e0f4&scoped=true&"
import script from "./OnboardingMatchingMissionFrequencyPage.vue?vue&type=script&lang=ts&"
export * from "./OnboardingMatchingMissionFrequencyPage.vue?vue&type=script&lang=ts&"
import style0 from "./OnboardingMatchingMissionFrequencyPage.vue?vue&type=style&index=0&id=c616e0f4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c616e0f4",
  null
  
)

export default component.exports